import styles from '@components/not-found/not-found.module.scss'
import { Link } from '@components/shared/link'

interface Props {
  message?: string
  href?: string
  hrefMessage?: string
}
export const NotFound = ({
  message = 'Page Not Found',
  href,
  hrefMessage,
}: Props) => (
  <div className={styles.container}>
    <div className={styles.title}>{message}</div>
    {href && (
      <Link className={styles.link} href={href}>
        {hrefMessage}
      </Link>
    )}
  </div>
)
